import React from 'react'

import { Box } from 'ui/components/Box'
import {
    Dropdown,
    DropdownButton,
    DropdownContent,
    DropdownHeadSearch,
    DropdownItemComplex,
    DropdownItemTag,
    DropdownSeparator,
} from 'ui/components/Dropdown'
import { Tag } from 'ui/components/Tag'
import { stopPropagation } from 'ui/helpers/utilities'

import { useAppTemplateTagEditorState } from './hooks/useAppTemplateTagEditorState'
import { AppTemplate } from './types'

type AppTemplateTagEditorProps = React.ComponentPropsWithoutRef<typeof Box> & {
    template: AppTemplate
    onChange?: (template: Partial<AppTemplate>) => void
}

export const AppTemplateTagEditor: React.FC<AppTemplateTagEditorProps> = ({
    template,
    onChange,
    ...props
}) => {
    const {
        existingOptions,
        onCheckedChange,
        isSelected,
        selectedOptions,
        searchQuery,
        setSearchQuery,
        showAddNewTagOption,
    } = useAppTemplateTagEditorState({
        template,
        onChange,
    })

    return (
        <Box flex center wrap gap="xs" {...props}>
            {selectedOptions.map((option) => (
                <Tag
                    key={option.value}
                    size="xs"
                    type="solid"
                    shape="rectangle"
                    color={option.color}
                    shade="light"
                    onRemove={() => onCheckedChange(option.value, false)}
                    showRemoveButton
                >
                    {option.label}
                </Tag>
            ))}
            <Dropdown modal={false}>
                <DropdownButton startIcon={{ name: 'Plus' }} variant="dotted" size="xs">
                    Add tag
                </DropdownButton>
                <DropdownContent
                    style={{ minWidth: '300px' }}
                    side="bottom"
                    align="start"
                    onClick={stopPropagation}
                    searchQuery={searchQuery}
                    setSearchQuery={setSearchQuery}
                    head={<DropdownHeadSearch placeholder="Filter tags or add new..." />}
                >
                    {existingOptions.map((option) => (
                        <DropdownItemTag
                            key={option.value}
                            label={option.label}
                            checked={isSelected(option.value)}
                            onCheckedChange={(checked) => onCheckedChange(option.value, checked)}
                            color={option.color}
                            closeOnSelect={true}
                            multiSelect
                        />
                    ))}
                    {showAddNewTagOption && (
                        <>
                            {existingOptions.length > 0 && <DropdownSeparator />}
                            <DropdownItemComplex
                                label="Add new tag"
                                subtitle={searchQuery}
                                onSelect={() => onCheckedChange(searchQuery, true)}
                                startIcon={{ name: 'Plus' }}
                            />
                        </>
                    )}
                </DropdownContent>
            </Dropdown>
        </Box>
    )
}
